import { useMutation, useQueryClient } from '@tanstack/react-query'

import { markAllRead, markRead } from './notifications-api'
import { notificationKeys } from './query-keys'

export function useMarkRead() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id: string) => markRead(id),
    // No optimistic update: the server's answer drives the read state.
    onSuccess: () => queryClient.invalidateQueries({ queryKey: notificationKeys.all }),
  })
}

export function useMarkAllRead() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: () => markAllRead(),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: notificationKeys.all }),
  })
}
